import { MouseEventHandler, createElement } from 'react';
import { ClientSelection } from 'src/entities/client';
import { HOC } from 'src/shared/componentBuilder';
import { omit } from 'lodash';
import { useAuthInterceptor } from './useAuthInterceptor';

interface AuthProps extends ClientSelection {
  onClick?: MouseEventHandler<HTMLElement>;
}

const arrOfInternalKeys: Array<keyof AuthProps> = [
  'address',
  'careerId',
  'catalogType',
  'cityId',
  'clientType',
  'location',
  'name',
  'tariffId',
  'urgencyScore',
];

/**
 * Run auth process for guest users before original action
 */
export const withAuth: HOC<AuthProps> = (Component) => (props) => {
  const interceptor = useAuthInterceptor();
  return createElement(Component, {
    ...omit(props, ...arrOfInternalKeys),
    onClick: props.onClick ? interceptor(props.onClick, props) : undefined,
  });
};
